export enum BillableNephrectomyStatus {    
    Unknown = 0,
    PendingDataEntry = 1,
    SentToRecipientCenter = 2,
    SubmittedByRecipientCenter = 22,
    PendingMoreDataByRecipientCenter = 3,
    AcceptedByRecipientCenter = 4,
    AcceptedByRecipientCenterDueToNonResponse = 5,
    DisputedByRecipientCenter = 8,
    PaymentReceivedByRecipientCenter = 10,
    PaymentSentToDonorCenter = 20,
    TimedOutDonorCenterDidNotSubmit = 99,
    BilledManually = -1
}